// extracted by mini-css-extract-plugin
export default {"navbarItems":"_2KtSz0FE6PvWkmV3TfPYsj"};